import SVGIconWrapper from "./SVGIconWrapper"

const IconCalendarFirst = (props) => (
    <SVGIconWrapper
        fill={props.fill ?? "#fff"}
        style={props.style}
        viewBox="0 0 337.008 337.008"
        iconClass={`icon--calendar-first ${props.iconClass}`}
        wrapperClass={props.wrapperClass}
        onClick={props.onClick}
    >
        <path style={{fill: props.fill ?? "#000"}} d="M232.906,26.349V0h-11.711v26.349H115.804V0h-11.71v26.349H13.174v89.292v221.367h310.66V115.641
			V26.349H232.906z M24.885,38.059h79.209V61.48h11.71V38.059h105.391V61.48h11.711V38.059h79.212v65.872H24.885V38.059z
			 M312.118,325.298H24.885V115.641h287.238v209.657H312.118z" />
		<polygon style={{fill: props.fill ?? "#000"}} points="143.065,180.844 165.965,168.487 166.372,168.487 166.372,283.579 183.594,283.579 
			183.594,151.873 168.396,151.873 139.623,167.275"/>
    </SVGIconWrapper>
)

export default IconCalendarFirst